import { Box, Form, MaterialTextInput, ModalDialog, SpacerNew, Text } from '@jfs/ui-new'
import { ButtonNew as Button } from '../../components/AdminButton'
import { DropdownOptimised } from '../../components/DropdownNew'

interface AddNewDeviceModelProps {
  show: boolean
  onDismiss: () => void
  onPress: (args: any) => void
  errorMessage: string
  isLoading: boolean
}
export const AddNewDeviceModel = ({ show, onDismiss, onPress, errorMessage, isLoading }: AddNewDeviceModelProps) => {
  return (
    <ModalDialog show={show} onDismiss={onDismiss} type="CenteredWrap" title={'Add new Device Variant'}>
      <Box
        backgroundColor={'WHITE'}
        width={'50vw'}
        p={20}
        pb={60}
        borderBottomLeftRadius={20}
        borderBottomRightRadius={16}>
        <Form
          container={({ children }) => <Box width={'100%'}>{children}</Box>}
          formData={AddNewDeviceForm({ errorMessage })}
          actionButtons={(props) => (
            <Button
              {...props}
              title={'Add Device'}
              type={'primaryFullWidth'}
              height={42}
              isLoading={isLoading}
              onPress={() => onPress(props.values)}
              disabled={!props?.values?.variantName || props?.values?.variantName?.length < 5}
            />
          )}
        />
      </Box>
    </ModalDialog>
  )
}

interface AddNewDeviceFormProps {
  errorMessage: string
}

export const AddNewDeviceForm = ({ errorMessage }: AddNewDeviceFormProps) => [
  {
    verticalSpacing: 0,
    formItems: [
      {
        fieldName: FORM_FIELDS.variantName,
        placeholder: 'Enter Device Varient Name',
        ComponentName: MaterialTextInput,
        //tintColor: Colors.LIGHT_SKY_BLUE,
        // bottomLineColor: Colors.LIGHT_SKY_BLUE,
        //placeholderTextColor: Colors.DISABLED_GREY as ColorOptions, //For label color
        //color: 'DISABLED_GREY' as ColorOptions,
        //  ...styles.textInputStyle,
        maxLength: 50,
      },
      {
        fieldName: FORM_FIELDS.type,
        label: 'Select Device Type',
        ComponentName: DropdownOptimised,
        data: [
          { id: 'VOICEBOX', value: 'VOICEBOX' },
          { id: 'SQR', value: 'SQR' },
        ],
        //tintColor: Colors.LIGHT_SKY_BLUE,
        // bottomLineColor: Colors.LIGHT_SKY_BLUE,
        //placeholderTextColor: Colors.DISABLED_GREY as ColorOptions, //For label color
        //color: 'DISABLED_GREY' as ColorOptions,
        //  ...styles.textInputStyle,
      },

      {
        fieldName: FORM_FIELDS.error,
        ComponentName: Text,
        value: errorMessage,
        color: 'RED',
      },
      {
        fieldName: 'SPACER_1',
        ComponentName: SpacerNew,
        size: 15,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

export const FORM_FIELDS = {
  variantName: 'variantName',
  type: 'variantType',
  error: 'error',
}
